import moment from 'moment';

export const handleClickNueva = async (datosVisita, navigate) => {
    const fechaPeriodo = moment(`${datosVisita?.mes} ${datosVisita?.anio}`, 'MMMM YYYY').startOf('month').format('DD/MM/YYYY');
    
    navigate('/misVisitas/nuevaVisita', {
        state: {
            isNew: true,
            idVisita: 0,
            idPaciente: datosVisita?.idPaciente,
            idProfesional: datosVisita?.idProfesional,
            idTipoProfesional: datosVisita?.idTipoProfesional,
            idFiguraProfesional: datosVisita?.idFiguraProfesional,
            figuraProfesional: datosVisita?.figuraProfesional,
            idTipoModulo: datosVisita?.idTipoModulo,
            idEvaluacion: datosVisita?.idEvaluacion,
            programa: datosVisita?.programa,
            idFrecuencia: datosVisita?.idFrecuencia,
            visitasProgramadas: `${datosVisita?.visitasRealizadas} / ${datosVisita?.visitasEstimadas}`,
            periodo: datosVisita?.fechaAsignacion,
            periodoCoordinador: fechaPeriodo,
            desdeCoordinacion: true
        },
    });
}